import { PortableText } from "@portabletext/react";

type TProps = {
  value: any;
};

const RichText = (props: TProps) => {
  const { value } = props;

  return (
    <div className="rich-text">
      <PortableText value={value} />
    </div>
  );
};

export { RichText };
